<div class="step-card">
  <form
    class="step-form"
    [formGroup]="budgetsForm"
    (ngSubmit)="onSubmitToLocalStorage()"
  >

    <!-- Ligne 1 : Décaissement + Imputation -->
    <div class="form-section">
      <div class="form-row">
        <div class="field">
          <app-input
            type="number"
            formControlName="DecaissementEstimatif"
            label="Montant estimatif ( en milier de FCFA HT )"
            [thousandSeparator]="true"
          />
<!--           @if (budgetsForm.get('DecaissementEstimatif')?.touched && budgetsForm.get('DecaissementEstimatif')?.invalid) {
            <small class="field-error">Le montant décaissé estimatif est requis.</small>
          } -->
        </div>
        <div class="field">
          <app-select
            label="Imputation budgétaire"
            formControlName="imputationBudgetaire"
            [options]="ligneBudgetaires"
          />
<!--           @if (budgetsForm.get('imputationBudgetaire')?.touched && budgetsForm.get('imputationBudgetaire')?.invalid) {
            <small class="field-error">L'imputation budgétaire est requise.</small>
          } -->
        </div>
      </div>

      <!-- Ligne 2 : Horizon + Encaissement -->
      <div class="form-row">
        <div class="field">
          <app-select
            label="Horizon"
            formControlName="horizon"
            [options]="horizonData"
          />
<!--           @if (budgetsForm.get('horizon')?.touched && budgetsForm.get('horizon')?.invalid) {
            <small class="field-error">L'horizon est requis.</small>
          } -->
        </div>
        <div class="field">
          <app-input
            type="number"
            formControlName="coutPrevuN"
            label="Coût prévu année N-1 ( en milliers de FCFA HT )"
            [thousandSeparator]="true"
          />
        </div>
      </div>

      <!-- Ligne 3 : Prévisions N+1 / N+2 -->
      <div class="form-row">
        
        <div class="field">
          <app-input
            type="number"
            formControlName="PrevisionDecaissementT3N"
            label="Montant décaissé au 30 sept de année N ( en milliers de FCFA HT )"
            [thousandSeparator]="true"
          />
        </div>
        
        <div class="field">
          <app-input
            type="number"
            formControlName="PrevisionDecaissementT4N"
            label="Prévision de décaissement au T4 de année N ( en milliers de FCFA HT )"
            [thousandSeparator]="true"
          />
        </div>
      </div>
      <!-- Ligne 4 : Prévisions N+1 / N+2 -->
      <div class="form-row">
        <div class="field">
          <app-input
            type="number"
            formControlName="coutPrevuN1"
            label="Coût prévu année N ( en milliers de FCFA HT )"
            [thousandSeparator]="true"
          />
<!--           @if (budgetsForm.get('coutPrevuN1')?.touched && budgetsForm.get('coutPrevuN1')?.invalid) {
            <small class="field-error">La prévision N+1 est requise.</small>
          } -->
        </div>
        
        <div class="field">
          <app-input
            type="number"
            formControlName="previsionDecaissementN1"
            label="Coût prévu année N+1 ( en milliers de FCFA HT )"
            [thousandSeparator]="true"
          />
<!--           @if (budgetsForm.get('previsionDecaissementN1')?.touched && budgetsForm.get('previsionDecaissementN1')?.invalid) {
            <small class="field-error">La prévision N+1 est requise.</small>
          } -->
        </div>
      </div>
      <!-- Ligne 5 : Prévisions N+1 / N+2 -->
      <div class="form-row">
        
        <div class="field">
          <app-input
            type="number"
            formControlName="previsionDecaissementN2"
            label="Coût prévu année N+2 ( en milliers de FCFA HT )"
            [thousandSeparator]="true"
          />
<!--           @if (budgetsForm.get('previsionDecaissementN2')?.touched && budgetsForm.get('previsionDecaissementN2')?.invalid) {
            <small class="field-error">La prévision N+2 est requise.</small>
          } -->
        </div>
        <div class="field">
          <app-input
            type="number"
            formControlName="previsionDecaissementN3"
            label="Coût prévu année N+3 ( en milliers de FCFA HT )"
            [thousandSeparator]="true"
          />
<!--           @if (budgetsForm.get('previsionDecaissementN2')?.touched && budgetsForm.get('previsionDecaissementN2')?.invalid) {
            <small class="field-error">La prévision N+2 est requise.</small>
          } -->
        </div>
      </div>
    </div>

    <!-- Actions -->
    <div class="actions">
      <button type="button" class="btn btn-secondary btn-md" (click)="goBack()">
        <span class="material-icons btn-icon btn-icon--left">arrow_back</span>
        Précédent
      </button>
      <button type="submit" class="btn btn-primary btn-md">
        Suivant
        <span class="material-icons btn-icon btn-icon--right">arrow_right_alt</span>
      </button>
    </div>

  </form>
</div>

<!-- Modal de confirmation -->
<app-modal
  [isVisible]="showSubmitActiviteModal"
  title="Confirmer la soumission"
  (closeEvent)="closeSubmitActiviteModal()"
>
  <div class="modal-body">
    <div class="modal-message">
      <span class="modal-message__icon material-icons">help_outline</span>
      <p class="modal-message__text">Voulez-vous soumettre cette activité ?</p>
    </div>
    <div class="modal-actions">
      <button type="button" class="btn btn-secondary btn-md" (click)="closeSubmitActiviteModal()">
        <span class="material-icons btn-icon btn-icon--left">close</span>
        Annuler
      </button>
      <button type="button" class="btn btn-primary btn-md" (click)="onSubmitActiviteConfirm()">
        <span class="material-icons btn-icon btn-icon--left">check_circle</span>
        Confirmer
      </button>
    </div>
  </div>
</app-modal>